<app-dialog-popup #dialog>
  <div dialog-header>
    <span>clang-format's options</span>
  </div>
  <div dialog-body>
    @if (formatter) {
      <dl>
        <dt>Load style from:</dt>
        <dd>
          <dl>
            <dt>Preset:</dt>
            <dd>
              <select #newStyle>
                <option value="llvm">LLVM</option>
                <option value="google">Google</option>
                <option value="chromium">Chromium</option>
                <option value="mozilla">Mozilla</option>
                <option value="webKit">WebKit</option>
                <option value="gnu">GNU</option>
                <option value="microsoft">Microsoft</option>
                <option value="clangFormat">ClangFormat</option>
                <option value="none">None</option>
              </select>
              <button type="button" (click)="loadStyle()">Load</button>
            </dd>
          </dl>
        </dd>
        <dd>
          <dl>
            <dt>File:</dt>
            <dd>
              <button type="button" (click)="fileInput.click()">Browse</button>
              <input #fileInput class="display-none" type="file" (change)="loadYamlFromFile($event)">
            </dd>
          </dl>
        </dd>
        <dd>
          <dl>
            <dt>Text:</dt>
            <textarea #textClangConfig rows="5"></textarea>
            <dd>
              <button type="button" (click)="loadYamlFromText()">Load</button>
            </dd>
          </dl>
        </dd>
      </dl>
      <dl>
        <dt>Save style to:</dt>
        <dd>
          <dl>
            <dt>File</dt>
            <dd>
              <button type="button" (click)="downloadYaml()">Save</button>
            </dd>
          </dl>
        </dd>
        <dd>
          <dl>
            <dt>Clipboard</dt>
            <dd>
              <button type="button" (click)="saveYamlToText()">Copy</button>
            </dd>
          </dl>
        </dd>
      </dl>
      <details [attr.open]='enableClangFormatExpert() ? true : null' (toggle)="onEnableClangFormatExpert($event)">
        <summary>All parameters</summary>
        <app-formatter-options [emptyStyle]="emptyStyle!" [formatStyle]="formatStyle!" [formatter]="formatter!"
          (changeOptions)="reformat()" />
      </details>
    }
  </div>
</app-dialog-popup>

<app-textarea-two inputPlaceholder="Enter your C++ code here" [inputChange]="format">
  <div header-input>
    <h2>Your unformatted C++ code</h2>
  </div>
  <div header-output>
    <h2>Your formatted C++ code<lucide-icon name="settings" (click)="dialog.openDialog()" /></h2>
  </div>
</app-textarea-two>

@if (isLoading()) {
  <app-spinner-loading [size]="spinnerSize()" [title]="titleLoading" />
}

<a href="https://github.com/bansan85/web-demangler">
  <app-github-mark-inline class="github_logo" />
</a>